import React from "react";
import PropTypes from "prop-types";
import ImageWithBasePath from "core/img/imagewithbasebath";
import { format } from "date-fns";

const EmployeeHeader = ({ employee }) => {
  console.log("Employee Data in Header:", employee);
  return (
    <div className="col-lg-12 mb-2">
      <div className="employee-header-inline">
        {/* Avatar */}
        <div className="emp-inline-avatar">
          {employee?.employeePhoto !== "" ? (
            <img src={employee?.employeePhoto} alt={employee?.fullName} />
          ) : (
            <ImageWithBasePath
              src={
                employee?.gender === "M"
                  ? "assets/img/profiles/men.png"
                  : "assets/img/profiles/women.png"
              }
              alt="Employee"
            />
          )}
        </div>

        {/* Name + Role */}
        <div className="emp-inline-main">
          <div className="emp-name">
            {employee?.fullName}
            <span className="emp-code">{employee?.uniqueId}</span>
          </div>
          <div className="emp-role">
            {employee?.departmentname} / {employee?.designationName}
          </div>
        </div>

        {/* Meta Info */}
        <div className="emp-inline-meta">
          <span>
            <i className="fa fa-birthday-cake" /> {employee?.dob || ""}
          </span>
          <span>
            <i className="fa fa-star" />
            {(employee?.joinDate && employee?.joinDate) || ""}
            {/* {(employee?.joinDate &&
              format(new Date(employee?.joinDate), "dd-MM-yyyy")) ||
              ""} */}
          </span>
          <span>
            <i className="fa fa-users" />{" "}
            {employee?.gender === "M"
              ? "Male"
              : employee?.gender === "F"
              ? "Female"
              : "Others"}
          </span>
          <span className="email">
            <i className="fa fa-envelope" /> {employee?.email}
          </span>
        </div>
      </div>
    </div>
  );
};

EmployeeHeader.propTypes = {
  employee: PropTypes.object.isRequired,
};

export default EmployeeHeader;
